import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { WelcomeEffects, WelcomeReducer } from './state/welcome';

@NgModule({
  imports: [
    StoreModule.forFeature('welcome', WelcomeReducer.reducer),
    EffectsModule.forFeature([WelcomeEffects]),
  ]
})
export class WelcomeStateModule { }
